//在线答疑
export const CHAT_STU_LIST = 'chat_stu_list'
export const CHAT_DETAIL = 'chat_detail'
export const CHAT_REPLAY_STU = 'chat_replay_stu'
export const CHAT_DEL = 'chat_del'
export const CHAT_EDIT = 'chat_edit'



// WEBPACK FOOTER //
// ./src/store/chat/type.js